<template>
  <span v-if="isLoading">Loading...</span>
  <Note v-else/>
</template>

<script>
import Note from './note';

export default {
  components: {
    Note,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async created() {
    if (this.$store.showInvoice) {
      this.isLoading = true;
      try {
        const result = await this.$store.dispatch('payment/showinvoice', {
          id: this.$store.invoiceId,
        });
        this.$store.invoice = result;
        this.$store.showNote = true;
        this.$store.payments = {
          selected: result.payments,
        };
      } catch (err) {
        this.$error({ message: 'Unable to fetch invoice' });
      }
      this.isLoading = false;
    }
  },
};
</script>
